import * as Yup from 'yup';

const newRegistro = {
    data: '',
    localEstoque: null,
    produto: null,
    unidadeCompra: null,
    unidadeEstoque: null,
    qtdConversao: 1,
    movimentaEstoque: false,
    quantidade: 0,
    quantidadeEstoque: 0,
    custoUnitario: 0,
    valorTotal: 0,
    obs: '',
};

const validation = Yup.object().shape({
    data: Yup.date()
        .required('Este campo é obrigatório'),
    localEstoque: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    produto: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    quantidade: Yup.number()
        .typeError('Este campo é obrigatório')
        .positive('Por Favor, informe um valor maior que zero')
        .required("Este campo é obrigatório"),
    custoUnitario: Yup.number()
        .typeError('Este campo é obrigatório')
        .positive('Por Favor, informe um valor maior que zero')
        .required("Este campo é obrigatório"),
    obs: Yup.string()
        .max(1000, 'Campo deve ter menos do que 1000 caracteres'),
});

export const implantacaoEstoque = {
    newRegistro,
    validation
}